import { render, staticRenderFns } from "./FiltroLateral.vue?vue&type=template&id=0a2144ae&scoped=true"
import script from "./FiltroLateral.vue?vue&type=script&lang=js"
export * from "./FiltroLateral.vue?vue&type=script&lang=js"
import style0 from "./FiltroLateral.vue?vue&type=style&index=0&id=0a2144ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2144ae",
  null
  
)

export default component.exports